const config = {
  ACCESS_TOKEN_COOKIE_NAME: process.env.ACCESS_TOKEN_COOKIE_NAME || 'edx-jwt-cookie-header-payload',
  BASE_URL: process.env.BASE_URL || 'http://localhost:8000',
  CREDENTIALS_BASE_URL: process.env.CREDENTIALS_BASE_URL || process.env.LMS_BASE_URL || 'http://localhost:8000',
  CSRF_TOKEN_API_PATH: process.env.CSRF_TOKEN_API_PATH || '/csrf/api/v1/token',
  ECOMMERCE_BASE_URL: process.env.ECOMMERCE_BASE_URL || process.env.LMS_BASE_URL || 'http://localhost:8000',
  LANGUAGE_PREFERENCE_COOKIE_NAME: process.env.LANGUAGE_PREFERENCE_COOKIE_NAME || 'openedx-language-preference',
  LMS_BASE_URL: process.env.LMS_BASE_URL || 'http://localhost:8000',
  LOGIN_URL: process.env.LOGIN_URL || (process.env.LMS_BASE_URL ? process.env.LMS_BASE_URL + '/authn/login' : 'http://localhost:8000/login'),
  LOGOUT_URL: process.env.LOGOUT_URL || '/logout',
  MARKETING_SITE_BASE_URL: process.env.MARKETING_SITE_BASE_URL || process.env.LMS_BASE_URL || 'http://localhost:8000',
  REFRESH_ACCESS_TOKEN_ENDPOINT: process.env.REFRESH_ACCESS_TOKEN_ENDPOINT || '/login_refresh',
  SEGMENT_KEY: process.env.SEGMENT_KEY || null,
  SITE_NAME: process.env.SITE_NAME || 'localhost',
  USER_INFO_COOKIE_NAME: process.env.USER_INFO_COOKIE_NAME || 'edx-user-info',
  LOGO_URL: process.env.LOGO_URL || 'https://edx-cdn.org/v3/default/logo.svg',
  LOGO_TRADEMARK_URL: process.env.LOGO_TRADEMARK_URL || 'https://edx-cdn.org/v3/default/logo-trademark.svg',
  LOGO_WHITE_URL: process.env.LOGO_WHITE_URL || 'https://edx-cdn.org/v3/default/logo-white.svg',
  FAVICON_URL: process.env.FAVICON_URL || 'https://edx-cdn.org/v3/default/favicon.ico',
  MFE_CONFIG_API_URL: process.env.MFE_CONFIG_API_URL || '/api/mfe_config/v1',
  STUDIO_BASE_URL: process.env.STUDIO_BASE_URL || 'http://localhost:8001',
  SESSION_COOKIE_DOMAIN: process.env.SESSION_COOKIE_DOMAIN || 'localhost',
  APP_ID: process.env.APP_ID || null,
};

export default config;
